export const MAX_AMOUNT_DIGITS = 4;
export const MAX_AMOUNT = 1500;

export const MAX_NAME_CHARS = 'UVUVWEVWEVWE ONYETENYEVWE UGWEMUBWEM OSAS'
  .length;

export const MAX_EMAIL_CHARS = 254;

export const SEND_DATE_DISPLAY_FORMAT = 'DD/MM/YY';
